var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-2"},[_vm._l((_vm.menuEntries),function(entry){return _c('MenuEntry',{key:entry.id,attrs:{"entry":entry}})}),(_vm.isAdminAndIpadOrWeb)?_c('MenuEntry',{attrs:{"entry":_vm.adminEntry}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }